$(document).ready(function () {

    if( $('.page-template-tpl-kiosque').length ) {

        $('body').on('click', '._3d-flip-book', function(e) {
            setTimeout(() => {
                $(".fb3d-modal iframe").contents().find(".cmdSave, .cmdPrint").css("display", "none"); 
            }, 1000);
        });
    }
});
